let markerclusterSettings = {
    styles: [
        {
            height: 87,
            width: 96,
            url: "/wp-content/themes/BiosynexExacto/static/images/map-clusters/cluster1.svg",
            textColor: '#ffffff',
        },
        {
            height: 97,
            width: 106,
            url: "/wp-content/themes/BiosynexExacto/static/images/map-clusters/cluster2.svg",
            textColor: '#ffffff',
        },
        {
            height: 114,
            width: 123,
            url: "/wp-content/themes/BiosynexExacto/static/images/map-clusters/cluster3.svg",
            textColor: '#ffffff',
        }
    ]
};

export {
    markerclusterSettings
}



// WEBPACK FOOTER //
// ./assets/scripts/map/include/_markerclustersSettings.js